import List from './list'
import Upload from './upload'

export default function(prefix, app) {
  return app
    .useRoute(`${prefix}/list/upload/:id`, Upload)
    .useRoute(`${prefix}/list`, List)
}
